// Local storage keys
const TOKEN_KEY = 'directus_auth_token';
const TOKEN_EXPIRY_KEY = 'directus_token_expiry';
const REFRESH_TOKEN_KEY = 'directus_refresh_token';

export function getAuthToken(): { token: string; expiry: number } | null {
  const token = localStorage.getItem(TOKEN_KEY);
  const expiry = localStorage.getItem(TOKEN_EXPIRY_KEY);

  if (!token || !expiry) {
    return null;
  }

  return {
    token,
    expiry: parseInt(expiry),
  };
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export const storeTokens = (
  accessToken: string,
  refreshToken: string,
  expires: number
): void => {
  localStorage.setItem(TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  localStorage.setItem(TOKEN_EXPIRY_KEY, (Date.now() + expires).toString());
};

export function logout(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_EXPIRY_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}

export function redirectToLogin() {
  logout();
  window.location.href =
    '/login?redirect=' + encodeURIComponent(window.location.pathname);
}
